<template>
	<div class="login__content">
		<h1>Mandato Aberto</h1>
		<form @submit.prevent="registerUser" id="registeroffice">
			<div class="form__group form__group--two-columns">
				<label for="name">{{'name' | translate | capitalize }}</label>
				<input name="name" type="text" id="nome" v-model="formDataPost.name" required>
				<ul class="validation" v-if="apiValidation.form_error.name">
					<li class="validation__error">{{ apiValidation.form_error.name | translate }}</li>
				</ul>
			</div>
			<div class="form__group form__group--two-columns">
				<label for="email">{{ 'email' | translate | capitalize }}</label>
				<input name="email" type="email" v-model="formDataPost.email" required>
				<ul class="validation" v-if="apiValidation.form_error.email">
					<li class="validation__error">{{ apiValidation.form_error.email | translate }}</li>
				</ul>
			</div>
			<div class="form__group form__group--two-columns">
				<label for="password">{{ 'password' | translate | capitalize }}</label>
				<input name="password" type="password" id="password" v-model="formDataPost.password" minlength="6" required>
				<ul class="validation" v-if="apiValidation.form_error.password">
					<li class="validation__error">{{ apiValidation.form_error.password | translate }}</li>
				</ul>
			</div>

			<!-- <div class="form__group form__group--two-columns">
				<label>{{ 'gender' | translate | capitalize }}</label>
					<ul class="ul-register">
						<li class="inline">
						<label class="label-inline">
							<input class="input__option radio" type="radio" name="gender" value="M" v-model="formDataPost.gender" @click="genderChoice($event)" required>
							{{ 'male' | translate | capitalize }}
						</label>
						</li>
						<li class="inline">
						<label class="label-inline">
							<input class="input__option radio" type="radio" name="gender" value="F" v-model="formDataPost.gender" @click="genderChoice($event)">
							{{ 'female' | translate | capitalize  }}
						</label>
						</li>
					</ul>
			</div> -->
			<div class="form__group form__group--two-columns">
				<label>{{ 'gender' | translate | capitalize }}</label>
				<select name="party" class=" arrow-up" v-model="formDataPost.gender" required>
					<option value="M">{{ 'male' | translate | capitalize }}</option>
					<option value="F">{{ 'female' | translate | capitalize  }}</option>
				</select>
				<ul class="validation" v-if="apiValidation.form_error.gender">
					<li class="validation__error">{{ apiValidation.form_error.gender | translate }}</li>
				</ul>
			</div>
			<div class="form__group form__group--two-columns">
				<label>{{ 'party' | translate | capitalize }}</label>
				<select name="party" class=" arrow-up" v-model="formDataPost.party_id" required>
					<option></option>
					<option v-for="party in parties" :value="party.id" :key="party.id">{{ party.name }}</option>
				</select>
				<ul class="validation" v-if="apiValidation.form_error.party">
					<li class="validation__error">{{ apiValidation.form_error.party | translate }}</li>
				</ul>
			</div>
			<div class="form__group form__group--two-columns">
				<label>{{ 'office' | translate | capitalize }}</label>
				<select name="office" id="" v-model="formDataPost.office_id" required :disabled="(!officer.offices) ? true : false">
				<option></option>
				<option v-for="office in officer.offices" :value="office.id" :key="office.id">{{office.name}}</option>
				</select>
				<ul class="validation" v-if="apiValidation.form_error.office_id">
					<li class="validation__error">{{ apiValidation.form_error.office_id | translate }}</li>
				</ul>
			</div>
			<div class="form__group form__group--two-columns">
				<label>{{ 'movement' | translate | capitalize }}</label>
				<select name="movement" class=" arrow-up" v-model="formDataPost.movement_id">
				<option></option>
				<option v-for="movement in movements" :value="movement.id" :key="movement.id">{{ movement.name }}</option>
				</select>
			</div>
			<div class="form__group form__group--two-columns">
				<label>{{ 'state' | translate | capitalize}}</label>
				<select name="state" list="state" v-model="formDataPost.address_state_id" @change="getCities" required>
				<option disabled></option>
				<option v-for="state in states.state" :value="state.id" :key="state.id">{{state.name}}</option>
				</select>
				<ul class="validation" v-if="apiValidation.form_error.address_state_id">
					<li class="validation__error">{{ apiValidation.form_error.address_state_id | translate }}</li>
				</ul>
			</div>
			<div class="form__group form__group--two-columns">
				<label>{{ 'city' | translate | capitalize }}</label>
				<select class=" arrow-up" name="city" v-model="formDataPost.address_city_id" :disabled="(!cities.city) ? true : false">
				<option disabled></option>
				<option v-for="city in cities.city" :value="city.id" :key="city.id">{{city.name}}</option>
				</select>
				<ul class="validation" v-if="apiValidation.form_error.address_city_id">
					<li class="validation__error">{{ apiValidation.form_error.address_city_id | translate }}</li>
				</ul>
			</div>

			<div class="login__submit">
				<div class="form__validation" v-show="successMsg">
					<p><i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}</p>
				</div>
				<div class="form__group submit__content">
					<button type="submit">{{ 'register' | translate | capitalize }}</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	/* eslint-disable key-spacing,object-shorthand */

	import modal from '../modal/modal.vue';

	export default {
		name: 'register',
		components: {
			modal,
			// error,
		},
		data() {
			return {
				formDataPost: {
					name: '',
					email: '',
					password: '',
					address_state_id: '',
					address_city_id: '',
					party_id: '',
					office_id: '',
					movement_id: '',
					gender: '',
				},
				submitLoading: false,
				successMsg: false,
				pagesSession: {},
				stateValue: [],

				modalComponent: {
					display: '',
					msg: 'Cadastrado com sucesso',
				},
				apiValidation: {
					form_error: {},
				},
			};
		},
		computed: {
			states() {
				return this.$store.state.register.states;
			},
			movements() {
				return this.$store.state.register.movements;
			},
			cities() {
				return this.$store.state.register.citys;
			},
			officer() {
				return this.$store.state.register.office;
			},
			parties() {
				return this.$store.state.register.partys;
			},
			success() {
				return this.$store.state.status;
			},
		},
		methods: {


			getCities() {
				this.$store.dispatch('citiesOfState', this.formDataPost.address_state_id);
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			registerUser() {
				const payload = {};

				if (this.formDataPost.name) {
					payload.name = this.formDataPost.name;
				}

				if (this.formDataPost.email) {
					payload.email = this.formDataPost.email;
				}

				if (this.formDataPost.password) {
					payload.password = this.formDataPost.password;
				}

				if (this.formDataPost.gender) {
					payload.gender = this.formDataPost.gender;
				}

				if (this.formDataPost.party_id) {
					payload.party_id = this.formDataPost.party_id;
				}

				if (this.formDataPost.office_id) {
					payload.office_id = this.formDataPost.office_id;
				}

				if (this.formDataPost.movement_id) {
					payload.movement_id = this.formDataPost.movement_id;
				}

				if (this.formDataPost.address_state_id) {
					payload.address_state_id = this.formDataPost.address_state_id;
				}

				if (this.formDataPost.address_city_id) {
					payload.address_city_id = this.formDataPost.address_city_id;
				}

				this.$store.dispatch('registerUser', payload)
					.then(() => {
						this.validate();
					})
					.catch((error) => {
						this.apiValidation = error.response.data;
						this.validationError = '';
						this.toggleSubmitLoading();
					});
			},
			validate() {
				if (this.success) {
					this.successMsg = this.success;
					this.$data.formDataPost = {};
					this.$router.push({ path: '/', query: { plan: 'approved' } });
				}
			},
			genderChoice(event) {
				this.$store.dispatch('getOffice', event.target.value);
			},
		},
		mounted() {
			this.$store.dispatch('getParty');
			this.$store.dispatch('stateCountry');
			this.$store.dispatch('getMovement');
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/register/register.vue